export default __webpack_public_path__ + "static/media/vuilwatertank.31f51a74.svg";